import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useReference } from "@/lib/useReference";
import { schoolYear } from "@/components/PageHeader";

const ALL = "__all__";

export function FilterBar({ value, onChange, showYear = true }) {
  const { ref } = useReference();
  const campuses = ref.campuses.filter((c) => !value.district_id || c.district_id === value.district_id);
  const teams = ref.teams.filter((t) => !value.campus_id || t.campus_id === value.campus_id);
  const years = Array.from(new Set(ref.teams.map((t) => t.year))).sort((a, b) => b - a);

  const set = (patch) => onChange({ ...value, ...patch });
  const pick = (k) => (v) => {
    const val = v === ALL ? "" : v;
    if (k === "district_id") set({ district_id: val, campus_id: "", team_id: "" });
    else if (k === "campus_id") set({ campus_id: val, team_id: "" });
    else set({ [k]: val });
  };

  return (
    <div className="mb-5 flex flex-wrap items-end gap-3" data-testid="filter-bar">
      <div className="space-y-1.5">
        <Label className="text-xs">District</Label>
        <Select value={value.district_id || ALL} onValueChange={pick("district_id")}>
          <SelectTrigger className="w-40" data-testid="filter-district"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={ALL}>All districts</SelectItem>{ref.districts.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs">Campus</Label>
        <Select value={value.campus_id || ALL} onValueChange={pick("campus_id")}>
          <SelectTrigger className="w-40" data-testid="filter-campus"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={ALL}>All campuses</SelectItem>{campuses.map((c) => <SelectItem key={c.id} value={c.id}>{c.name} ({c.code})</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs">Team</Label>
        <Select value={value.team_id || ALL} onValueChange={pick("team_id")}>
          <SelectTrigger className="w-40" data-testid="filter-team"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={ALL}>All teams</SelectItem>{teams.map((t) => <SelectItem key={t.id} value={t.id}>{t.name} ({t.code})</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {showYear && (
        <div className="space-y-1.5">
          <Label className="text-xs">Year</Label>
          <Select value={value.year ? String(value.year) : ALL} onValueChange={(v) => set({ year: v === ALL ? "" : parseInt(v, 10) })}>
            <SelectTrigger className="w-28" data-testid="filter-year"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value={ALL}>All years</SelectItem>{years.map((y) => <SelectItem key={y} value={String(y)}>{schoolYear(y)}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}

export function buildQuery(value) {
  const p = new URLSearchParams();
  if (value.district_id) p.set("district_id", value.district_id);
  if (value.campus_id) p.set("campus_id", value.campus_id);
  if (value.team_id) p.set("team_id", value.team_id);
  if (value.year) p.set("year", value.year);
  return p.toString();
}

export default FilterBar;
